import React from 'react';
import PropTypes from 'prop-types';
import { StyledCellTd, StyledCellTh } from './style';

const Cell = ({ children, tagName, ...props }) =>
  tagName === 'th' ? (
    <StyledCellTh {...props}>{children}</StyledCellTh>
  ) : (
    <StyledCellTd {...props}>{children}</StyledCellTd>
  );

Cell.propTypes = {
  children: PropTypes.node,
  tagName: PropTypes.oneOf(['td', 'th'])
};

Cell.defaultProps = {
  children: undefined,
  tagName: 'td'
};

export default Cell;
